export default __webpack_public_path__ + "static/services-detailsdw-33124c63f2bfd26b6988c3e1d429b34d.jpg";